var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items)?_c('PaginatedTable',{attrs:{"fields":_vm.fields,"pageable":_vm.pageable,"page":_vm.page},on:{"change":_vm.pageableChanged}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }